import ComponentManager from "../../componentFramework";
import {default as JsfAjaxStatus, CustomStatusElementCallback} from "../../scripts/jsf/JsfAjaxStatus";
import {JsfAjaxEvent, JsfAjaxRequestEvent} from "../../scripts/jsf/JsfAjax";

/**
 */
@ComponentManager.register()
export default class EditContentAjaxStatus {
	public static componentStyleClass = "editContentAjaxStatus";

	private static readonly labelValue_saved = "Draft Saved";
	private static readonly labelValue_working = "Working";

	private readonly labelElement: HTMLElement | null;

	constructor(private readonly rootElement: HTMLElement) {
		this.labelElement = rootElement.querySelector(".editContentAjaxStatus__label");

		this.setLabel(EditContentAjaxStatus.labelValue_saved);

		// Watch for ajax status updates
		JsfAjaxStatus.getInstance().addEventBeginListener(this.onJsfAjaxStatusEventBegin);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		JsfAjaxStatus.getInstance().removeEventBeginListener(this.onJsfAjaxStatusEventBegin);
	}

	private readonly onJsfAjaxStatusEventBegin = (
		event: JsfAjaxRequestEvent,
		addStatusElement: (elem: Element, onComplete?: CustomStatusElementCallback) => void
	) => {
		addStatusElement(this.rootElement, this.onJsfAjaxStatusEventComplete);

		this.setLabel(EditContentAjaxStatus.labelValue_working);
	}

	private readonly onJsfAjaxStatusEventComplete = (ev: JsfAjaxEvent, customStatusElem?: Element) => {
		if (this.rootElement === undefined) {
			return; // This instance probably had destroy() called during the ajax event.
		}
		this.setLabel(EditContentAjaxStatus.labelValue_saved);
		// TODO: What if there was an error? It should not say "saved" then... So I actually need "on success" and "on error". ... But I don' think Josh's code is right either. It could be any error... We need Java to tell us via an ajax refresh of just the label... With that we don't even need this callback.
	}

	private setLabel(label: string) {
		if (this.labelElement !== null) {
			this.labelElement.innerText = label;
		}
	}
}
